export function Singleton<T>(): any {
    abstract class SingletonClass {
        /**
         * Singleton instance of the class
         */
        private static __SELF__: T;

        /**
         * Instance getter
         */
        public static get instance() {
            return this.getInstance();
        }

        /**
         * Get a singleton instance of the class
         */
        public static getInstance(): T {
            if (!this.__SELF__) {
                // @ts-ignore
                this.__SELF__ = new this();
            }

            return this.__SELF__;
        }
    }

    return SingletonClass as any;
}
